<template>
  <v-row class="addOn-wrapper">
    <v-col>
      <v-row class="app-container--width-max mx-auto">
        <v-col cols="12" class="title-wrapper">
          <h2 class="mb-3">What additional cover is available?</h2>
          <p>
            {{ additionalCoverDes }}
          </p>
        </v-col>
        <v-col
          cols="12"
          class="d-flex justify-space-between add-on__item-wrapper"
        >
          <div
            class="add-on__item"
            v-for="(addOn, index) in addOns"
            :key="index"
          >
            <div class="img-wrapper">
              <img
                :src="require(`@/assets/images/${addOn.icon}`)"
                :alt="addOn?.icon"
              />
            </div>
            <h3 v-html="addOn?.title"></h3>
            <p>
              {{ addOn?.description }}
            </p>
          </div>
        </v-col>
        <v-col class="text-center btn-wrapper">
          <v-btn
            :ripple="false"
            depressed
            rounded
            color="mustard"
            x-large
            class="font-weight-bold font-18 text-uppercase mx-auto"
            @click="$emit('openCreateLLQuoteDialog')"
            aria-label="Get a new quote"
          >
            Get a new quote
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ADD_ONS } from "@/constants/d2c-landing-page.constants";
export default {
  name: "LandingPageWhatAdditionalCover",
  props: {
    addOns: {
      type: Array,
      default: () => ADD_ONS,
    },
    additionalCoverDes: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.addOn-wrapper {
  background: #eff0f0;
  padding: 44px 0 28px 0;
  .add-on__item {
    background-color: #fff !important;
    max-width: 249px;
    padding: 24px 16px 21px 16px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
    .img-wrapper {
      max-height: 100px;
    }
    h3 {
      padding-bottom: 28px;
      padding-top: 11px;
      font-size: 16px;
      min-height: 87px;
    }
    p {
      text-align: left;
    }
  }
}
@media screen and (max-width: $grid-breakpoints-lg - 1) {
  .addOn-wrapper {
    padding: 9px 0 28px 0;
    .add-on__item-wrapper {
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .add-on__item {
        min-width: 249px;
        margin-right: 14px;
      }
    }
    .col {
      padding-right: 0;
      &.title-wrapper {
        padding-right: 40px !important;
      }
      .app-container--width-max {
        padding-right: 0 !important;
      }
      .btn-wrapper {
        padding-right: 40px !important;
      }
    }
  }
}
</style>
